export const toAbsoluteUrl = (pathname: string): string =>
  process.env.PUBLIC_URL + pathname;
